<template>
    <b-tab
        :active="active"
        @click="$emit('click', $event)"
        @input="$emit('input', $event)"
        v-bind="$props"
    >
        <slot name="title" />
        <slot />
    </b-tab>
</template>

<script>
import { BTab } from 'bootstrap-vue'

export default {
    components: { BTab },
    props: {
        active: { type: Boolean, default: false },
        isVisible: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        title: { type: String, default: '' },
        titleItemClass: { type: [Array, Object, String] },
    }
}
</script>
